import React from "react";
import PropTypes from "prop-types";
import Section from "../../common/Section";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import * as domainConstants from '../../../constants/DomainConstants';
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import FinancieelTableComponent from "../parts/FinancieelTableComponent";
import { Popup } from 'semantic-ui-react';

const KostenForm = (props) => {
    const {
        model,
        color,
        okiTypes,
        disabled,
        goToKostEdit,
        showDeleteModal,
        goToKostEditWijzig
    } = props;

    function mapOnShowDeleteModal(id) {
        return function (event) {
            showDeleteModal(event, id);
        };
    }

    function mapOnEdit(id) {
        return function (event) {
            goToKostEditWijzig(event, id);
        };
    }

    const isIngediend = model.redenVanStatus.toString() === domainConstants.REDEN_VAN_STATUS_INGEDIEND;
    const noModelsContent = "Je hebt nog geen kosten ingegeven voor deze kostensoort.";

    const getContent = (titel, models, subtypes, showSubHeader) => {
        const subTypeModels = subtypes.map((subtype) => (
            {
                subtypeId: subtype.id,
                titel: subtype.titel,
                models: models.filter(m => m.subtypeId === subtype.id),
                opbrengstenOfKostenPosten: subtype.opbrengstenOfKostenPosten
            }
        ));
        const content = subTypeModels.map((subtypeModel) => {
            const tableSettings = {
                tableHeaders: ["KOSTENPOST", "OMSCHRIJVING", "TOTAAL", ""],
                tableHeaderSizes: [2, 7, 2, 1],
                noModelsContent: noModelsContent,
                hasRows: subtypeModel.models.length > 0,
                tableRows: subtypeModel.models.map((oki, i) => {
                    const opbrengstenOfKostenPost = subtypeModel.opbrengstenOfKostenPosten.find(m => m.value === oki.opbrengstenOfKostenPostId);
                    const opbrengstenOfKostenPostOmschrijving = opbrengstenOfKostenPost ? opbrengstenOfKostenPost.label : null;
                    const tdStyle = oki.volledig ? null : { color: 'orange' };

                    return (<tr key={"kostenopbrengensten_" + i}>
                        <td style={tdStyle}>{opbrengstenOfKostenPostOmschrijving}</td>
                        <td style={tdStyle}>{oki.omschrijving}</td>
                        <td style={tdStyle}>{"€ " + oki.bedragTotaal.toLocaleString('nl-BE')}</td>
                        <td>
                {isIngediend ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={mapOnShowDeleteModal(oki.id)} />} content="verwijder kostenpost" /></span>}
                            <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={mapOnEdit(oki.id)} />} content="wijzig kostenpost" />
                            </span>
                        </td>
                    </tr >);
                })
            };

            return (<div key={"SUBTYPE_" + subtypeModel.subtypeId}>
                {showSubHeader ? <FieldsetSubHeader>{subtypeModel.titel}</FieldsetSubHeader> : null}
                <FinancieelTableComponent
                    settings={tableSettings}
                    disabled={disabled} />
            </div>);
        });
        return <Fieldset title={titel}>{content}</Fieldset>;
    };

    const bedrijfskostenType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.Bedrijfskost);
    const financieleKostenType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.FinanciëleKost);
    const uitzonderlijkeKostenType = okiTypes.find(m => m.id == domainConstants.KostenOpbrengstenInvesteringMainTypes.UitzonderlijkeKost);

    const bedrijfskostenModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == bedrijfskostenType.id);
    const financieleKostenModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == financieleKostenType.id);
    const uitzonderlijkeKostenModels = model.opbrengstKostInvesteringen.filter(m => m.typeId == uitzonderlijkeKostenType.id);

    const bedrijfskosten = getContent("BEDRIJFSKOSTEN", bedrijfskostenModels, bedrijfskostenType.subtypes, true);
    const financieleKosten = getContent("FINANCIELE KOST", financieleKostenModels, financieleKostenType.subtypes, false);
    const uitzonderlijkeKosten = getContent("UITZONDERLIJKE KOST", uitzonderlijkeKostenModels, uitzonderlijkeKostenType.subtypes, false);

    return (<Section title={domainConstants.FinancieelTitels.FinancieleDuurzaamheid} color={color}>
        <Form
            title="Overzicht kosten"
            name="overzichtKosten"
            leftButtonLabel={isIngediend ? null : "Voeg kosten toe"}
            onLeftButtonClick={goToKostEdit}
            rightTopButtonLabel={isIngediend ? null : "Voeg kosten toe"}
            onRightTopButtonClick={goToKostEdit}
            isNotRequired
        >
            {bedrijfskosten}
            {financieleKosten}
            {uitzonderlijkeKosten}
        </Form>
    </Section>);
};

KostenForm.propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    okiTypes: PropTypes.array,
    model: PropTypes.object,
    goToKostEdit: PropTypes.func.isRequired,
    showDeleteModal: PropTypes.func,
    goToKostEditWijzig: PropTypes.func
};

export default KostenForm;